import { render, staticRenderFns } from "./c-confirm-delete-modal.vue?vue&type=template&id=36b82d76&scoped=true&"
import script from "./c-confirm-delete-modal.vue?vue&type=script&lang=js&"
export * from "./c-confirm-delete-modal.vue?vue&type=script&lang=js&"
import style0 from "./c-confirm-delete-modal.vue?vue&type=style&index=0&id=36b82d76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b82d76",
  null
  
)

export default component.exports